<template>
	<div full-height>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Verify OTP</v-toolbar-title>
		</v-toolbar>

		<div class="hasToolbar">

			<v-card noshadow>
				<v-card-text>

					<v-form class="form-element">
						<v-container justify-center align-center row fill-height>

							<v-layout align-center row wrap style="max-width:400px">

								<v-layout row wrap v-if="!changeNumber">
									<p class="title grey-color" style="line-height:28px !important">
						        		We have sent an OTP on this number: <span dark-opacity-color><strong>{{'+'+$route.query.mobile_number}}</strong></span>
						        	</p>
								</v-layout>

								<v-layout row wrap v-if="changeNumber">

									<v-flex xs12 sm12 md12>
									  	<p class="title grey-color" style="line-height:28px !important">
						        			Old Number: <span dark-opacity-color><strong>{{'+'+$root.CurrentBusiness.BusinessProfileNumber}}</strong></span>
						        		</p>
									</v-flex>
									
									<v-flex xs12 sm12 md12>
						               <v-text-field  
						               		v-model="Form.OldNumberCode" 
						               		mask="######"
						               		label="Enter OTP (For old number)" 
						               		type="tel"
						               		placeholder=" "
						               		v-validate="'required'"
						               		data-vv-name="otpold" 
						               		data-vv-as="otp" 
						               		:error-messages="errors.collect('otpold')"
						               		required>
						               	</v-text-field>
						            </v-flex>

						            <v-flex xs12 sm12 md12 mb-3 left-align nopadding v-if="timeOut">
						               	<v-btn color="primary" class="pl-0" flat nomargin @click="fn_getHashKey('resend', 'old')">Resend</v-btn>
						            </v-flex>

						            <v-flex xs12 sm12 md12>
									  	<p class="title grey-color" style="line-height:28px !important">
						        			New Number: <span dark-opacity-color><strong>{{'+91'+$route.query.mobile_number}}</strong></span>
						        		</p>
									</v-flex>

						            <v-flex xs12 sm12 md12>
						               <v-text-field  
						               		v-model="Form.NewNumberCode" 
						               		mask="######"
						               		clearable
						               		label="Enter OTP (For new number)" 
						               		type="tel"
						               		placeholder=" "
						               		v-validate="'required|min:6'"
						               		data-vv-name="otpnew" 
						               		data-vv-as="otp" 
						               		:error-messages="errors.collect('otpnew')"
						               		required>
						               	</v-text-field>
						            </v-flex>

						            <v-flex xs12 sm12 md12 left-align nopadding v-if="timeOut">
						               	<v-btn color="primary" class="pl-0" flat nomargin @click="fn_getHashKey('resend', 'new')">Resend</v-btn>
						            </v-flex>

								</v-layout>


								<v-layout row wrap mt-3 v-else>
								  
									<v-flex xs12 sm12 md12 nopadding>
						               <v-text-field  
						               		v-model="Form.Code"
						               		mask="######"
						               		clearable
						               		hide-details
						               		type="tel"
						               		label="Enter OTP"
						               		placeholder=" "
						               		v-validate="'required|min:6'"
						               		data-vv-name="otp" 
						               		data-vv-as="otp" 
						               		required>
						               			
						               	</v-text-field>
						            </v-flex>

								</v-layout>


					            <v-flex xs12 sm12 md12 margin-top-ten right-align nopadding>
					               	<v-btn color="primary" nomargin @click="fn_checkValidation">Confirm</v-btn>
					            </v-flex>

							</v-layout>
						</v-container>
					</v-form>
				</v-card-text>
			</v-card>

			<div class="page-footer" style="bottom:42px;">
                <!-- <div class="watermark">
                    <div class="title">BizOps</div>
                </div> -->
                <div class="branding">
					<a href="https://bizopsapp.com/" target="_blank">
						<div class="font11">Powered By</div>
						<div class="title primary-color">
							<img class="brand_logo" src="../../assets/Final_BizOpsLogo.svg" alt="bizops_logo">BizOps App
						</div>
					</a>
				</div>
            </div>
		</div>
		
		<v-footer bottom-fixed-footer form-item v-if="timeLeft>0">
		  Resend OTP in: {{timeLeft}} seconds
		</v-footer>

		<v-snackbar :timeout="0" v-model="snackbarSendOtp">Resend OTP
			<v-btn flat color="primary" @click.native="fn_getHashKey('resend')">Okay</v-btn>
		</v-snackbar>

		<v-snackbar :timeout="0" v-model="msgAlert">Something went wrong. Try again!
			<v-btn flat color="primary" @click.native="fn_checkValidation">retry</v-btn>
		</v-snackbar>
	</div>
</template>

<script>

var otpTimer = null;

	export default{
		data(){
			return{
				Form:{"VerificationCodeID":null, "Code":null, "DataDriveLocation":null, "OldNumberCode":null, "NewNumberCode":null, "RequestID":null, "changeNumberResponse":null},
				loading:true,
				changeNumber:false,
				verificationData:null,
				timeLeft:null,
				timeOut:false,
				snackbarSendOtp:false,
				msgAlert:false
			}
		},
		methods:{

			fn_getHashKey: function(type, changeNumberType){
                let self = this;
                this.getData('GetHashKey', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.showLoading('Please wait...');
                            if(type=='resend'){
                            	self.$root.fn_getAuthToken(function(token){
									self.fn_resendOtp(response, token, changeNumberType)
								})
                            }
                            else{
                            	self.$root.fn_getAuthToken(function(token){
                            		if(self.$route.query.requestType == 4){
                            			self.fn_getOtpForChangeNumber(response, token);
                            		}
                            		else{
                            			self.fn_getOtpFromServer(response, token);
                            		}
								})
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast("Something went wrong. Try again")
                        }
                    }
                );
            },

            fn_getOtpFromServer: function(hashKey, token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                let self = this;

                let filterObject = {};
                // filterObject.PhoneNumber = "+91"+this.$route.query.mobile_number;
                filterObject.PhoneNumber = this.$route.query.mobile_number;
                filterObject.HashKey = hashKey;
                filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
                filterObject.RequestType = this.$route.query.requestType ? Number(this.$route.query.requestType) : null;
                filterObject.token = token;

                this.postServerData('BusinessSendOTP', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       let data = JSON.parse(response);
                       self.Form.RequestID = data.RequestID;
                       self.fn_setTimer();	
                       self.showToast("OTP Sent");
                       self.hideLoading();
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       self.snackbarSendOtp = true;
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })
            },

            fn_getOtpForChangeNumber: function(hashKey, token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                let self = this;

                let filterObject = {};
                filterObject.PhoneNumber = "91"+this.$route.query.mobile_number;
                filterObject.HashKey = hashKey;
                filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
                filterObject.RequestType = this.$route.query.requestType;
                filterObject.token = token;

                console.log(JSON.stringify(filterObject));

                this.postServerData('ChangeNumberSendOtp', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       let data = JSON.parse(response);
                       self.Form.changeNumberResponse = data;
                       self.fn_setTimer();
                       self.showToast("OTP Sent");
                       self.hideLoading();
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       self.fn_goBack();
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })
            },

            fn_resendOtp: function(hashKey, token, changeNumberType){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                let self = this;

                let filterObject = {};
                filterObject.HashKey = hashKey;

                if(changeNumberType){
                	filterObject.RequestID = changeNumberType == 'old' ? this.Form.changeNumberResponse.OldNumber.RequestID : this.Form.changeNumberResponse.NewNumber.RequestID;
                }
                else{
                	filterObject.RequestID = this.Form.RequestID;	
                }
                
                filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
                filterObject.token = token;
                this.snackbarSendOtp = false;

                this.postServerData('BusinessResendOTP', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       let data = JSON.parse(response);
                       if(changeNumberType){
                       		changeNumberType == 'old' ? self.Form.changeNumberResponse.OldNumber.RequestID = data.RequestID : self.Form.changeNumberResponse.NewNumber.RequestID = data.RequestID;
                       }
                       else{
                       	self.Form.RequestID = data.RequestID;	
                       }
                       self.fn_setTimer();
                       self.showToast("OTP Sent");
                       self.hideLoading();
                    }, 
                     onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       self.snackbarSendOtp = true;
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                     }, 
                 })
            },

			// fn_getOtp: function(){
			// 	let filterObject = {};
			// 	filterObject.phoneNumbers = {"oldNumber":"+"+this.$route.query.mobile_number}
			// 	this.$route.query && this.$route.query.changeRequest ? filterObject.changeRequest = true : '';

			// 	this.showLoading("Please wait...");

			// 	let self = this;
			// 	this.getFilterData('GetOTP', null, filterObject, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);

			// 				self.hideLoading();
			// 				self.snackbarSendOtp = false;

			// 				if(response=="phone number verified"){
			// 					self.fn_verifyCallBack(response);
			// 				}
			// 				else{
			// 					self.loading = false;
			// 					self.verificationData = JSON.parse(response);
			// 					self.fn_setTimer();
			// 					self.showToast("Otp Sent");
			// 				}
							
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	          	self.hideLoading();
			// 	          	self.showToast(error);
			// 	        }
			// 		}
		 //        );
			// },

			fn_setTimer: function(){
				let self = this;
				this.timeLeft = 90;
				this.timeOut = false;
				let otpTimer = setInterval(function(){
				  self.timeLeft -= 1;
				  if(self.timeLeft <= 0){
				  	clearInterval(otpTimer);
				  	self.timeOut = true;
				  	if(self.$route.query.requestType != 4){
				  		self.snackbarSendOtp = true;
				  	}
				  }
				}, 1000);
			},

			fn_verifyCallBack: function(tokenObj){
				this.$route.params.verifyCallback(this.Form.RequestID);
				// if(this.$route.query.requestType==4){
				// 	this.$route.params.verifyCallback();
				// }
				// else{
				// 	this.$route.params.verifyCallback(this.Form.RequestID);
				// }
			},

			// fn_setOtp: function(otp){
			// 	if(this.route.query && !this.route.query.changeRequest){
			// 		this.Form.Code = otp;
			// 		this.fn_verifyOtp();
			// 	}
			// },

			fn_checkValidation: function(){
				this.$validator.validateAll().then((result) => {
			        if (result) {
			        	// this.fn_verifyOtp();
			        	if(this.$route.query.requestType==4){
			        		this.fn_verifyChangeNumberOtp();
			        	}
			        	else{
			        		this.$route.params.verifyCallback(this.Form.RequestID, this.Form.Code);	
			        	}
			        }
			        else{
			        	this.showToast('Invalid OTP');
			        }
			    });
			},

			// fn_verifyOtp: function(){
			// 	this.showLoading('Please wait...');
			// 	let self = this;
			// 	this.$root.fn_getAuthToken(function(token){
			// 		self.fn_verify(token);
			// 	})
			// },

			// fn_verify: function(token){
   //              if(!navigator.onLine){
   //                  this.showToast('Internet not available');
   //                  this.hideLoading();
   //                  return;
   //              }

   //              let self = this;

   //              let filterObject = {};
   //              filterObject.RequestID = this.Form.RequestID;
   //              filterObject.OTP = this.Form.Code;
   //              filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;
			// 	filterObject.token = token;

   //              this.postServerData('BusinessVerifyOTP', filterObject, {
   //                  onSuccess: function(response){
   //                     console.log(response);
   //                     self.showToast('OTP verified');
   //                     // let data = JSON.parse(response);
   //                     self.fn_verifyCallBack(response);
   //                     // self.hideLoading();
   //                  }, 
   //                   onError: function(error){
   //                     console.log(error);
   //                     self.hideLoading();
   //                     if(typeof JSON.parse(error) == 'object'){
   //                       let response = JSON.parse(error);
   //                       self.showToast(response.Message);
   //                     }
   //                   }, 
   //               })
   //          },

            fn_verifyChangeNumberOtp: function(){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    return;
                }

                let self = this;

                let filterObject = this.Form.changeNumberResponse;
                // filterObject.RequestID = this.Form.RequestID;
                // filterObject.OTP = this.Form.Code;
                filterObject.OldNumber.OTP = this.Form.OldNumberCode;
                filterObject.NewNumber.OTP = this.Form.NewNumberCode
                filterObject.BusinessID = this.$root.CurrentBusiness.BusinessID;

				this.showLoading('Please wait...');

				this.$root.fn_getAuthToken(function(token){

					filterObject.token = token;

					console.log(JSON.stringify(filterObject));
					self.postServerData('VerifyChangeNumberOtp', filterObject, {
	                    onSuccess: function(response){
	                       console.log(response);
	                       self.showToast('OTP verified');
	                       self.$route.params.verifyCallback(self.$route.query.mobile_number);
	                       // self.showToast('Mobile Number changed');
	                       // self.hideLoading();
	                       // self.$router.go(-2);
	                    }, 
	                     onError: function(error){
	                       console.log(error);
	                       self.hideLoading();
	                       if(typeof JSON.parse(error) == 'object'){
	                         let response = JSON.parse(error);
	                         self.showToast(response.Message);
	                       }
	                    }, 
	                })
				})
            },

			// fn_verifyOtp: function(){
			// 	if(!navigator.onLine){
			// 		this.showToast('Internet not available');
			// 		return;
			// 	}

			// 	this.msgAlert = false;
				
			// 	let self = this;
			// 	let filterObject = {};
			// 	filterObject.phoneVerify = [];
			// 	let oldNumberVerifyObject = {}

			// 	oldNumberVerifyObject.verificationId = this.verificationData.oldNumber.verificationId;
			// 	oldNumberVerifyObject.code = this.Form.Code;
			// 	this.$route.query && this.$route.query.changeRequest ? oldNumberVerifyObject.changeRequest = true : '';
			// 	filterObject.phoneVerify.push(oldNumberVerifyObject);

			// 	//clearing otp send again timer
			// 	clearInterval(otpTimer);
			// 	this.timeLeft = null;

			// 	this.showLoading('Please wait...');
			// 	this.postFilterData('VerifyOTP', null, filterObject, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				self.showToast('OTP verified');
			// 				self.hideLoading();
			// 				self.fn_verifyCallBack(response);

			// 	        }, 
			// 	        onError: function(error){
			// 	        	// self.snackbarSendOtp = true;
			// 	        	self.hideLoading();
			// 	        	self.showToast('Something went wrong. Try again');
			// 	        	self.msgAlert = true;
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			fn_verifyOtpFailureCB: function(){
				this.msgAlert = true;
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){
			console.log(this.$route);

			if(this.$route.params && this.$route.params.dataDriveLocation){
				this.Form.DataDriveLocation = this.$route.params.dataDriveLocation;	
			}

			this.$route.query.requestType == 4 ? this.changeNumber = true : '';

			// this.fn_getOtp();
			this.fn_getHashKey();

			window.js_globals.fn_onBackPress = this.fn_goBack;
			// window.js_globals.fn_setOtp = this.fn_setOtp;

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/otp_verification.vue